import config from "./config/prod.env"
export default config;